import useDynamicFields from '@/views/components/dynamic-fields/hooks/useDynamicFields'
import { getCurrentInstance, onBeforeMount, ref } from '@vue/composition-api'

export default function useDocumentInformation(props) {
  const vm = getCurrentInstance().proxy
  const { resolveFields } = useDynamicFields()

  const titleModal = ref(null)

  const resolveTitle = () => {
    let elements = props.formDataObj.information.key
    if (elements.length <= 0) return
    elements = elements.map(({ field }) => field)
    return (titleModal.value = elements.join(' & '))
  }

  onBeforeMount(() => {
    resolveTitle()
  })

  return {
    titleModal,
    resolveFields,
  }
}
